import { useCallback } from "react";

type UseUserMediaErrorHandlerProps = {
  setIsVideoReady: (val: boolean) => void;
  setErrorState: (val: string | null) => void;
  setVideoConstraints: (val: MediaTrackConstraints) => void;
};

// // Handle fallback to front camera if environment is not available
export function useUserMediaErrorHandler({
  setIsVideoReady,
  setErrorState,
  setVideoConstraints,
}: UseUserMediaErrorHandlerProps) {
  return useCallback(
    (error: string | DOMException) => {
      setIsVideoReady(false);
      if (typeof error === "string") {
        setErrorState(error);
        return;
      }
      // DOMException or similar object
      if (
        (error as DOMException)?.name === "OverconstrainedError" ||
        (error as DOMException)?.name === "NotFoundError"
      ) {
        setVideoConstraints({ facingMode: "user" });
      } else if (
        (error as DOMException)?.name === "NotAllowedError" &&
        (error as DOMException)?.message?.includes("Permission denied")
      ) {
        setErrorState("CAMERA_PERMISSION_DENIED");
      } else {
        setErrorState("CAMERA_ERROR");
      }
    },
    [setIsVideoReady, setErrorState, setVideoConstraints]
  );
}
